export default [
  {
    path: '/learning-paths',
    name: 'learning-paths',
    component: () => import('@/pages/LearningPaths'),
  },
  {
    path: '/path/:id',
    name: 'playlist',
    component: () => import('@/pages/SelectedPath'),
  },
]
